module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/icon_lead_point_compare-228501d65a7cba71aba41fa73f56bf12.svg";